<template>
    <div class="hamburger" tabindex="0" :class="{open:active}" @click="$emit('click')"
            aria-label="Menu" role="button" aria-controls="navigation">
        <span></span>
        <span></span>
        <span></span>
    </div>
</template>
<script>
export default {
    name:"Hamburger",
    props:{
        active:Boolean
    },
    emits:['click']
}
</script>
<style lang="scss" scoped>
.hamburger{
    width: 30px;
    height: 19px;
    position: relative;
    //margin: 50px auto;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: .5s ease-in-out;
    -moz-transition: .5s ease-in-out;
    -o-transition: .5s ease-in-out;
    transition: .5s ease-in-out;
    cursor: pointer;
    span{
        display: block;
        position: absolute;
        height: 3px;
        width: 100%;
        background: #DC0303;
        border-radius: 3px;
        opacity: 1;
        left: 0;
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: .25s ease-in-out;
        -moz-transition: .25s ease-in-out;
        -o-transition: .25s ease-in-out;
        transition: .25s ease-in-out;
        &:nth-child(1) {
            top: 0px;
            -webkit-transform-origin: left center;
            -moz-transform-origin: left center;
            -o-transform-origin: left center;
            transform-origin: left center;
        }
        &:nth-child(2) {
            top: 8px;
            -webkit-transform-origin: left center;
            -moz-transform-origin: left center;
            -o-transform-origin: left center;
            transform-origin: left center;
        }
        &:nth-child(3) {
            top: 16px;
            -webkit-transform-origin: left center;
            -moz-transform-origin: left center;
            -o-transform-origin: left center;
            transform-origin: left center;
        }
    }
    &.open span{
        &:nth-child(1) {
            -webkit-transform: rotate(45deg);
            -moz-transform: rotate(45deg);
            -o-transform: rotate(45deg);
            transform: rotate(45deg);
            top: -3px;
            left: 4px;
        }
        &:nth-child(2){
            width: 0%;
            opacity: 0;
        }
        &:nth-child(3){
            -webkit-transform: rotate(-45deg);
            -moz-transform: rotate(-45deg);
            -o-transform: rotate(-45deg);
            transform: rotate(-45deg);
            top: 18px;
            left: 4px;
        }
    }
}
@media only screen and (min-width : $responsive-point) {
    .hamburger{
        display: none;
    }
}
</style>